export default __webpack_public_path__ + "fdd50d31ee39670163ce68e6e9718255.svg";